import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	numDevelopmentDeployments: {
		id: 'software-deployment-frequency-report.line-chart-by-environment.chart.tooltip.num-development-deployments',
		defaultMessage:
			'{numDeployments} development {numDeployments, plural, one {deployment} other {deployments}}',
		description: 'Display the number of development environment deployments',
	},
	numTestingDeployments: {
		id: 'software-deployment-frequency-report.line-chart-by-environment.chart.tooltip.num-testing-deployments',
		defaultMessage:
			'{numDeployments} testing {numDeployments, plural, one {deployment} other {deployments}}',
		description: 'Display the number of testing environment deployments',
	},
	numStagingDeployments: {
		id: 'software-deployment-frequency-report.line-chart-by-environment.chart.tooltip.num-staging-deployments',
		defaultMessage:
			'{numDeployments} staging {numDeployments, plural, one {deployment} other {deployments}}',
		description: 'Display the number of staging environment deployments',
	},
	numProductionDeployments: {
		id: 'software-deployment-frequency-report.line-chart-by-environment.chart.tooltip.num-production-deployments',
		defaultMessage:
			'{numDeployments} production {numDeployments, plural, one {deployment} other {deployments}}',
		description: 'Display the number of production environment deployments',
	},
	numUnmappedDeployments: {
		id: 'software-deployment-frequency-report.line-chart-by-environment.chart.tooltip.num-unmapped-deployments',
		defaultMessage:
			'{numDeployments} unmapped {numDeployments, plural, one {deployment} other {deployments}}',
		description: 'Display the number of unmapped environment deployments',
	},
	weekStartDate: {
		id: 'software-deployment-frequency-report.line-chart-by-environment.chart.tooltip.week-start-date',
		defaultMessage: 'Week of {date}',
		description: 'Display the start date of the hovered week in the bar chart',
	},
});
